import React, { useState, useEffect } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import SuccessAlert from "../child/Alert/SuccessAlert";
import DengerAlert from "../child/Alert/DengerAlert";
import Loader from "../child/Loder";

const ViewPromiotionPayment = () => {
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [ItemData, setItemData] = useState([]);
  const [RenterName, setRenterName] = useState("");
  const [HostName, setHostName] = useState("");
  const [loading, setLoading] = useState(true);
  const location = useLocation();
  const { item } = location.state || {};

  const { id } = useParams();
  const isEditMode = !!id;
  const navigate = useNavigate();

  useEffect(() => {
    if (!id) return;
  }, [isEditMode, id]);

  return (
    <div className="row gy-4">
      <div className="col-lg-4">
        {successMessage && (
          <SuccessAlert
            message={successMessage}
            onClose={() => setSuccessMessage("")}
          />
        )}
        {errorMessage && (
          <DengerAlert
            message={errorMessage}
            onClose={() => setErrorMessage("")}
          />
        )}
      </div>

      <div className="col-md-12">
        <div className="card h-100">
          <div className="card-body p-24">
            <div className="row">
              <div className="col-md-4">
                <span>
                  <strong>Transaction Id:</strong>{" "}
                </span>
                <p>{item?.transactionId}</p>
              </div>
              <div className="col-md-4">
                <span>
                  <strong>Amount($):</strong>{" "}
                </span>{" "}
                {item?.amount}
              </div>
              <div className="col-md-4">
                <span>
                  <strong>Payment Status:</strong>{" "}
                </span>{" "}
                {item?.paymentStatus}
              </div>
              <div className="col-md-4">
                <span>
                  <strong>Payment Method:</strong>{" "}
                </span>{" "}
                {item?.paymentMethod}
              </div>

              <div className="col-md-4" style={{ display: "flex" }}>
                <span>
                  <strong>Payment Date:</strong>&nbsp;{" "}
                </span>
                <p>
                  {item?.transactionDate
                    ? (() => {
                        const date = new Date(item.transactionDate);
                        const day = String(date.getDate()).padStart(2, "0");
                        const month = String(date.getMonth() + 1).padStart(
                          2,
                          "0"
                        );
                        const year = String(date.getFullYear());
                        return `${day}-${month}-${year}`;
                      })()
                    : "N/A"}
                </p>
              </div>

              <div className="col-md-4" style={{ display: "flex" }}>
                <span>
                  <strong>Start Date:</strong>&nbsp;
                </span>
                <p>
                  {item?.startDate
                    ? (() => {
                        const date = new Date(item.startDate);
                        const day = String(date.getDate()).padStart(2, "0");
                        const month = String(date.getMonth() + 1).padStart(
                          2,
                          "0"
                        );
                        const year = String(date.getFullYear());
                        return `${day}-${month}-${year}`;
                      })()
                    : "N/A"}
                </p>
              </div>

              <div className="col-md-4" style={{ display: "flex" }}>
                <span>
                  <strong>End Date:</strong>&nbsp;
                </span>
                <p>
                  {item?.endDate
                    ? (() => {
                        const date = new Date(item.endDate);
                        const day = String(date.getDate()).padStart(2, "0");
                        const month = String(date.getMonth() + 1).padStart(
                          2,
                          "0"
                        );
                        const year = String(date.getFullYear());
                        return `${day}-${month}-${year}`;
                      })()
                    : "N/A"}
                </p>
              </div>
              <div className="col-md-4">
                <span>
                  <strong>Plan Name:</strong>{" "}
                </span>{" "}
                {item?.promotionPlan}
              </div>

              <div className="col-md-4">
                <span>
                  <strong>Host name:</strong>{" "}
                </span>
                {item?.hostDetails?.firstName || "N/A"}
              </div>
              <div className="col-md-4">
                <span>
                  <strong>Host email:</strong>{" "}
                </span>{" "}
                {item?.hostDetails?.email}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ViewPromiotionPayment;
